import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: true
})
export class InitialsPipe implements PipeTransform {
  transform(name: string): string {
    /**
     * If you want to display more than 2 initials, set it to 3 or more...
     */
    const numberOfInisitalsToDisplay = 2;

    if(!name) return '';
    const splitName = name.trim().split(' ');
    return splitName.map(word => word.charAt(0).toUpperCase())
    .slice(0, numberOfInisitalsToDisplay)
    .join('');
  }
}
